import {
  AfterViewInit,
  Directive,
  ElementRef,
  OnDestroy,
  Optional,
  Renderer2,
} from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[cnpjMask]',
})
export class CnpjMaskDirective implements AfterViewInit, OnDestroy {
  private inputEl!: HTMLInputElement | null;
  private unlistenInput?: () => void;

  constructor(
    private host: ElementRef<HTMLElement>,
    private renderer: Renderer2,
    @Optional() private ngControl: NgControl
  ) {}

  ngAfterViewInit(): void {
    const hostEl = this.host.nativeElement;

    if (hostEl.tagName === 'INPUT') {
      this.inputEl = hostEl as HTMLInputElement;
    } else {
      this.inputEl = hostEl.querySelector('input');
    }

    if (!this.inputEl) {
      console.warn('cnpjMask: nenhum <input> encontrado no host.');
      return;
    }

    this.unlistenInput = this.renderer.listen(this.inputEl, 'input', (e: Event) => this.onInput(e));

    this.formatAndSync(this.inputEl.value, { emitToControl: false });
  }

  ngOnDestroy(): void {
    if (this.unlistenInput) this.unlistenInput();
  }

  private onInput(event: Event) {
    const target = event.target as HTMLInputElement;
    this.formatAndSync(target.value, { fromEvent: true });
  }

  private formatAndSync(
    rawValue: string,
    opts: { fromEvent?: boolean; emitToControl?: boolean } = {}
  ) {
    if (!this.inputEl) return;

    const numeric = rawValue.replace(/\D/g, '');
    const masked = this.applyCnpjMask(numeric);

    if (this.inputEl.value !== masked) {
      this.renderer.setProperty(this.inputEl, 'value', masked);
    }

    if (this.ngControl && this.ngControl.control) {
      try {
        this.ngControl.control.setValue(masked, { emitEvent: false });
      } catch (err) {}
    } else if (opts.fromEvent) {
      const ev = new Event('input', { bubbles: true, cancelable: true });
      this.inputEl.dispatchEvent(ev);
    }
  }

  private applyCnpjMask(digits: string) {
    let v = digits.replace(/\D/g, '');

    v = v.substring(0, 14);

    if (v.length <= 2) return v;
    v = v.replace(/^(\d{2})(\d)/, '$1.$2');

    if (v.length <= 6) return v;
    v = v.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3');

    if (v.length <= 10) return v;
    v = v.replace(/^(\d{2})\.(\d{3})\.(\d{3})(\d)/, '$1.$2.$3/$4');

    if (v.length <= 15) return v;
    v = v.replace(/(\d{4})(\d)/, '$1-$2');

    return v;
  }
}
